import { render, staticRenderFns } from "./ModalPolicyContract.vue?vue&type=template&id=20b39458&scoped=true"
import script from "./ModalPolicyContract.vue?vue&type=script&lang=js"
export * from "./ModalPolicyContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b39458",
  null
  
)

export default component.exports